import { render, staticRenderFns } from "./FormFieldIBAN.vue?vue&type=template&id=49dcb49b"
import script from "./FormFieldIBAN.vue?vue&type=script&lang=js"
export * from "./FormFieldIBAN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports